var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarker({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#134563;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Location",
    transform: "translate(232.000000, 376.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-200-320.3l-0.9-1.1c-0.6-0.8-15.9-18.7-15.9-29.4c0-9.3,7.6-16.8,16.8-16.8     s16.8,7.6,16.8,16.8c0,10.7-15.3,28.7-15.9,29.4L-200-320.3L-200-320.3z M-200-365.3c-8,0-14.4,6.5-14.4,14.4     c0,8.4,11.1,22.7,14.4,26.8c3.3-4.1,14.4-18.3,14.4-26.8C-185.6-358.8-192-365.3-200-365.3L-200-365.3z",
    id: "Fill-55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-200-344.4c-3.5,0-6.4-2.9-6.4-6.4s2.9-6.4,6.4-6.4s6.4,2.9,6.4,6.4S-196.5-344.4-200-344.4     L-200-344.4z M-200-354.8c-2.2,0-4,1.8-4,4s1.8,4,4,4c2.2,0,4-1.8,4-4S-197.8-354.8-200-354.8L-200-354.8z",
    id: "Fill-56"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.7d8c6c56a899a591af7cc4cab77aa33f.svg";
export { ForwardRef as ReactComponent };